<template>
  <div class="card p-3 mb-2">
    <div class="d-flex justify-content-between">
      <h5>Question {{ order + 1 }}</h5>
      <a href="javascript:;" @click="$emit('deletes', order)">DELETE</a>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-group">
          <label>Question Category</label>
          <v-select
            :clearable="false"
            v-model="question.category"
            :options="categorys"
            label="name"
            :reduce="(c) => c.name"
          />
        </div>
      </div>
      <div class="col-5">
        <div class="form-group">
          <!-- @TODO is this question field necesary -->
          <label>
            Question
            <span class="o70">(Optional)</span>
          </label>
          <input type="text" class="form-control" v-model="question.question" />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <!-- @TODO is this question field necesary -->
          <label>
            Worksheet Upload
            <span class="o70 mr-1">(Optional)</span>
            <help-tip
              title="The suggested work sheet if the student scores a 3 or lower."
            />
          </label>
          <div
            v-if="filename"
            class="has-file d-flex justify-content-between align-content-center"
          >
            <span class="has-file-text">{{ filename }}</span>
            <span
              class="has-file-delete"
              @click="question.filename = undefined"
            >
              <i class="fas fa-trash" />
            </span>
          </div>
          <div v-else>
            <input
              type="file"
              @change="upload"
              name="file"
              accept="*"
              class="form-control-file"
            />
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-2"></div>
      <div class="col-5">
        <h6>
          Tutor's Text
          <help-tip
            title="The text visible to tutor to help them grade the question"
          />
        </h6>
      </div>
      <div class="col-5">
        <h6>
          Assessment Text
          <help-tip title="The text displayed in reports" />
        </h6>
      </div>
    </div>
    <div class="row mb-1 align-items-center" v-for="i in [0, 1, 2, 3, 4, 5]">
      <div class="col-2">
        <b>Response {{ i }}</b>
      </div>
      <div class="col-5">
        <input
          type="text"
          class="form-control"
          v-model="question.tutorSentences[i].sentence"
        />
      </div>
      <div class="col-5">
        <input
          type="text"
          class="form-control"
          v-model="question.assessmentSentences[i].sentence"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "categorys", "order"],
  computed: {
    question: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.value;
      },
    },
    filename() {
      if (this.question.filename) {
        return this.question.filename.originalname;
      }

      return this.question.tempfilename;
    },
  },
  methods: {
    upload({ target: { files } }) {
      const file = files[0];

      let formData = new FormData();

      formData.append("file", file);

      this.question.newfile = true;
      this.question.file = formData;
      this.question.tempfilename = file.name;
    },
  },
};
</script>

<style scoped>
.has-file-delete {
  display: flex;
  width: 25px;
  height: 25px;
  justify-content: center;
  background-color: #ad0b0b;
  color: white;
  border-radius: 100px;
  font-size: 12px;
  align-items: center;
  cursor: pointer;
}

.has-file {
  border: 1px solid #ced4da;
  padding: 5px 10px !important;
  border-radius: 0.25rem;
}

.has-file-text {
  max-width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
